export const MARKETPLACE_SUMMARY = "Marketplace Summary"
export const IMPORT_MARKETPLACE_SUMMARY = "Import Marketplace Summary"
export const PROVINCE_MARKETPLACE_SUMMARY = "Province/State Summary"



export const MARKETPLACE_SUMMARY_FIELDS = [
    {id: 'name', label: 'Description', align: "left"},
    {id: 'amazon_ca', label: 'Amazon.ca', align: "center"},
    {id: 'amazon_com', label: 'Amazon.com', align: "center"},
    {id: 'walmart_ca', label: 'Walmart.ca', align: "center"},
    {id: 'walmart_com', label: 'Walmart.com', align: "center"},
    {id: 'ebay_ca', label: 'eBay.ca', align: "center"},
    {id: 'exponet_ca', label: 'Exponet.ca', align: "center"},
    {id: 'exponet_us', label: 'Exponet.ca (US)', align: "center"},
    {id: 'customer_ca', label: 'Customers', align: "center"}
]

export const MARKETPLACE_SUMMARY_PAGES = {
    TABLE: "table",
    PROVINCE_SUMMARY: 'province_summary',
    IMPORTED_FILES: 'imported_files'
}

export const IMPORTED_FILES_TITLE = "Imported Files"
export const VIEW_IMPORTED_FILES = "View Imported Files"
export const IMPORT_LOGS = "Import Logs"

// Marketplaces shown as tabs in the imported-files view. Tabs are derived
// from whatever the server actually has, but this controls ordering and acts
// as the fallback when a marketplace has no files yet.
export const IMPORTED_FILES_MARKETPLACES = [
    'Amazon.ca', 'Amazon.com', 'Walmart.ca', 'Walmart.com', 'eBay.ca', 'Exponet.ca'
]

// Friendly labels for a few columns whose camelCase form reads awkwardly.
export const IMPORTED_FILE_COLUMN_LABELS = {
    orderId: 'Order ID',
    settlementId: 'Settlement ID',
    sku: 'SKU',
    gtin: 'GTIN',
    qty: 'Qty',
    hsCode: 'HS Code',
    pstQstRemitByWalmart: 'PST/QST Remit by Walmart',
    pstQstRemitBySeller: 'PST/QST Remit by Seller',
    gstHstRemitBySeller: 'GST/HST Remit by Seller',
    gstHstRemitByWalmart: 'GST/HST Remit by Walmart',
    wfsGstHst: 'WFS GST/HST',
    wfsPstQst: 'WFS PST/QST',
    wmcAmount: 'WMC Amount',
    wmcPstQstAmount: 'WMC PST/QST Amount',
}

// Turns a camelCase field name into a human-readable column header.
export const prettifyColumn = (key) => {
    if (!key) return ''
    if (IMPORTED_FILE_COLUMN_LABELS[key]) return IMPORTED_FILE_COLUMN_LABELS[key]
    return key
        .replace(/([A-Z]+)/g, ' $1')
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^./, (c) => c.toUpperCase())
}

export const CANADA_MARKETPLACES = ['Amazon.ca', 'Walmart.ca', 'eBay.ca', 'Exponet.ca'];
export const USA_MARKETPLACES = ['Amazon.com', 'Walmart.com', 'Exponet.ca (US)'];
// tooltip names
export const BACK = "Back to Menu"
